import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SummaryAPI from '../../common/SummaryAPI'
import toast from 'react-hot-toast'
import AxiosToastError from '../../utils/AxiosToastError'
import Axios from '../../utils/Axios'

const ResetPassword = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [data, setData] = useState({
    email: "",
    newPassword: "",
    confirmPassword: ""
  })
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const validValue = Object.values(data).every(val => val)
  useEffect(() => {
    if (!(location?.state?.data?.success)) {
      navigate("/")
    }
    if (location?.state?.email) {
      setData((prev) => ({
        ...prev,
        email: location?.state?.email
      }))
    }
  }, [])
  const handleChange = (event) => {
    const { name, value } = event.target
    setData((prev) => ({
      ...prev,
      [name]: value
    }))
  }
  const handleSubmit = async (event) => {
    event.preventDefault()
    if (data.newPassword !== data.confirmPassword) {
      toast.error("New password and Entered Password are different!")
      return;
    }
    try {
      const response = await Axios({
        ...SummaryAPI.resetPassword,
        data: data
      })
      if (response.data.error) {
        toast.error(response.data.message)
      }
      if (response.data.success) {
        toast.success(response.data.message)
        navigate("/login")
        setData({
          email: "",
          newPassword: "",
          confirmPassword: ""
        })
      }
    } catch (error) {
      AxiosToastError(error)
    }
  }
  return (
    <section>
      <div>
        <p>Password</p>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor='newPassword'>New Password :</label>
            <div>
              <input
                type={showPassword ? "text" : "password"}
                id='newPassword'
                name='newPassword'
                value={data.newPassword}
                onChange={handleChange}
                placeholder='Enter your new password:'
              />
            </div>
          </div>
          <div>
            <label htmlFor='confirmPassword'>Confirm Password :</label>
            <div>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id='confirmPassword'
                name='confirmPassword'
                value={data.confirmPassword}
                onChange={handleChange}
                placeholder='Re-enter your password:'
              />
            </div>
          </div>
          <button disabled={!validValue}>Change Password</button>
        </form>
        <p>
          Already have an account? <Link to={"/login"}>Login</Link>
        </p>
      </div>
    </section>
  )
}

export default ResetPassword